import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen text-white">
      <div className="max-w-2xl mx-auto px-4 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors mb-10"
        >
          ← Back to OurSexQuiz
        </Link>

        <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
        <p className="text-sm text-slate-400 mb-10">Last updated: February 2026</p>

        <div className="space-y-8 text-slate-300 leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">What we collect</h2>
            <p>We collect only what is necessary to run your quiz session: two partner nicknames, two age ranges, and two anatomy selections. No email addresses, phone numbers, or real names are required or stored.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">How answers are stored</h2>
            <p>Your quiz answers are stored in our database. Your partner cannot see your individual answers, and you cannot see theirs. Only the shared matches are ever revealed — via a server-side computation that never exposes individual responses.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">Data retention</h2>
            <p>All session data is automatically deleted 90 days after your session was created. We do not retain backups of deleted sessions.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">Cookies and tracking</h2>
            <p>We do not use cookies. We use <a href="https://umami.is" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline underline-offset-2">Umami Analytics</a>, <a href="https://vercel.com/analytics" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline underline-offset-2">Vercel Analytics</a>, and <a href="https://ahrefs.com/web-analytics" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline underline-offset-2">Ahrefs Web Analytics</a> to understand how visitors use our site. These services are configured without cookies and we do not use them to identify individual visitors across sessions or websites. We also use localStorage in your browser solely to save your quiz progress so you can resume if you close the tab.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">Payments</h2>
            <p>Payments are processed by Stripe. We never see or store your card details.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">Contact</h2>
            <p>
              Questions? Email us at{' '}
              <a
                href="mailto:privacy@oursexquiz.com"
                className="text-primary hover:underline underline-offset-2"
              >
                privacy@oursexquiz.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
